import React from 'react';
import MediaPicker from '../MediaPicker';
import './FieldStyles.css';

const MediaField = ({ value, onChange, type, apiUrl, token, isEmpty }) => {
  const isImage = type === 'IMAGE';
  const effectiveToken = token || (typeof window !== 'undefined' ? localStorage.getItem('admin_token') : null);

  return (
    <div className={`field-wrapper media-field ${isEmpty ? 'empty' : ''}`}>
      <MediaPicker
        value={value}
        onChange={onChange}
        type={isImage ? 'IMAGE' : 'VIDEO'}
        token={effectiveToken}
      />
    </div>
  );
};

export default MediaField;
